
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fAnet", function(module, exports) {

$parcel$export(module.exports, "UpflowIframeComponent", () => $f101b7fdf659a238$export$a34263073bbb2ca1);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $5kYyR = parcelRequire("5kYyR");

var $3Zulo = parcelRequire("3Zulo");

var $e6KKH = parcelRequire("e6KKH");

var $8PILw = parcelRequire("8PILw");
const $f101b7fdf659a238$export$a34263073bbb2ca1 = ()=>{
    const [{ renderUpflowModal: renderUpflowModal, targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen }, { unMountUpflowModal: unMountUpflowModal }] = (0, $8PILw.useUpflowModal)();
    if (!renderUpflowModal) return null;
    const onModalDismissed = ()=>{
        unMountUpflowModal();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Zulo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "upflowIframeComponent",
        packageName: "jiraUpflowIframePlugin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "upflowIframeComponent",
        packageName: "jiraUpflowIframePlugin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e6KKH.UpFlowIFrame), {
        product: product,
        targetEdition: targetEdition,
        flow: flow,
        touchpointId: touchpointId,
        experienceTrackingEnabled: true,
        onClose: onClose || onModalDismissed,
        subRoute: subRoute,
        onOpen: onOpen || undefined
    }))));
};

});
parcelRegister("3Zulo", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $35e7d40f521eb281$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $35e7d40f521eb281$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $9XYcy = parcelRequire("9XYcy");
const $35e7d40f521eb281$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eJOHy.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    }
    return null;
};
const $35e7d40f521eb281$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($35e7d40f521eb281$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $35e7d40f521eb281$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $9XYcy.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eJOHy.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    }
    return null;
};
const $35e7d40f521eb281$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($35e7d40f521eb281$var$NonCriticalComponent, props));
var $35e7d40f521eb281$export$2e2bcd8739ae039 = $35e7d40f521eb281$var$NonCriticalComponent;

});

parcelRegister("e6KKH", function(module, exports) {

$parcel$export(module.exports, "UpFlowIFrame", () => $abe059e9dbd34e42$export$e9eafd8c579e773d);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");


var $g0EOn = parcelRequire("g0EOn");

var $eVWQM = parcelRequire("eVWQM");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $abe059e9dbd34e42$var$UpFlowIFrameLazy = (0, $bQWwW.lazy)(()=>(parcelRequire("61XLP")), {
    moduleId: "./src/packages/growth/up-flow/up-flow-iframe/src/main.tsx"
});
const $abe059e9dbd34e42$export$e9eafd8c579e773d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: (0, $ba7c2176b0883143$export$c73007a11ea7e52),
        packageName: (0, $ba7c2176b0883143$export$c73007a11ea7e52),
        teamName: "luna-growth",
        fallback: (0, $eVWQM.ChunkLoadErrorFlag),
        attributes: (0, $g0EOn.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "flow-iframe-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($abe059e9dbd34e42$var$UpFlowIFrameLazy, props)));

});
const $ba7c2176b0883143$export$c73007a11ea7e52 = 'jiraUpFlowIframe';
const $ba7c2176b0883143$export$cb7e587097a78810 = 'upsell-edition';
const $ba7c2176b0883143$export$fb320338324d1328 = 'upflowIFrame';
const $ba7c2176b0883143$export$782491eab0c2154d = 'INITIATE_SPA_CLOSE';
const $ba7c2176b0883143$export$dc3263ec2276f3f3 = 'START_EDITION_POLLING';
const $ba7c2176b0883143$export$8a7c66f5574473bd = 'FINISH_EDITION_POLLING';
const $ba7c2176b0883143$export$c012ea75b4437aea = 'TRACK_EXPERIENCE_FAIL';
const $ba7c2176b0883143$export$1b2e801262ba754 = 'TRACK_EXPERIENCE_SUCCESS';
const $ba7c2176b0883143$export$b6cceaecfde9dc91 = 'SPA_READY';

parcelRegister("g0EOn", function(module, exports) {

$parcel$export(module.exports, "applicationEditionToUpFlowEdition", () => $bdee86a39a5fad6f$export$b48ea9d6b982b3e1);
$parcel$export(module.exports, "jiraUpFlowIframeUpgradePlanInteraction", () => $bdee86a39a5fad6f$export$7d4045a899f62dfd);
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $bdee86a39a5fad6f$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "handleError", () => $bdee86a39a5fad6f$export$d3da1ecaf1206c58);

var $eJOHy = parcelRequire("eJOHy");

var $hqYEY = parcelRequire("hqYEY");

var $gYnSx = parcelRequire("gYnSx");

var $a9ldn = parcelRequire("a9ldn");

var $7Jk3f = parcelRequire("7Jk3f");



var $5ZHBx = parcelRequire("5ZHBx");
const $bdee86a39a5fad6f$export$e4e69593f7c9f3b7 = (attributes, error)=>{
    (0, $gYnSx.default)({
        meta: {
            // We use the same ID for all errors in the package for easier
            // management in data portal, and use attributes to identify an error instead.
            id: (0, $ba7c2176b0883143$export$c73007a11ea7e52),
            packageName: (0, $ba7c2176b0883143$export$c73007a11ea7e52),
            teamName: 'luna-growth'
        },
        attributes: {
            ...attributes
        },
        error: error
    });
};
const $bdee86a39a5fad6f$export$b48ea9d6b982b3e1 = (applicationEdition)=>{
    if (applicationEdition === (0, $a9ldn.FREE_EDITION)) return 0, $3189735ed9ba9352$export$e69af2c4378638a2;
    if (applicationEdition === (0, $a9ldn.STANDARD_EDITION)) return 0, $3189735ed9ba9352$export$7bc7dd5faba7ad6b;
    return 0, $3189735ed9ba9352$export$3fd0bbb8c68dc4c7;
};
const $bdee86a39a5fad6f$export$7d4045a899f62dfd = (0, $hqYEY.metrics).interaction({
    key: `${(0, $ba7c2176b0883143$export$c73007a11ea7e52)}.upgrade.plan`
});
const $bdee86a39a5fad6f$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7Jk3f.isLoaderError)(error)
    });
const $bdee86a39a5fad6f$export$d3da1ecaf1206c58 = (subject, onClose, apiError)=>{
    $bdee86a39a5fad6f$export$e4e69593f7c9f3b7({
        subject: subject,
        message: apiError?.message || ''
    }, apiError);
    $bdee86a39a5fad6f$export$7d4045a899f62dfd.cancel();
    onClose();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ZHBx.CommerceApiErrorFlag), null);
};

});
const $3189735ed9ba9352$export$e69af2c4378638a2 = 'free';
const $3189735ed9ba9352$export$7bc7dd5faba7ad6b = 'standard';
const $3189735ed9ba9352$export$3fd0bbb8c68dc4c7 = 'premium';

parcelRegister("5ZHBx", function(module, exports) {

$parcel$export(module.exports, "CommerceApiErrorFlag", () => $5f92f7e6c55d527f$export$7ee77c445dd775b4);

var $bILK0 = parcelRequire("bILK0");

var $hrodw = parcelRequire("hrodw");

var $58Vhi = parcelRequire("58Vhi");
const $5f92f7e6c55d527f$export$7ee77c445dd775b4 = ()=>{
    const flagKey = (0, $hrodw.toFlagId)('commerce-api-error');
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $58Vhi.default).title,
        description: (0, $58Vhi.default).description,
        isAutoDismiss: true,
        messageId: 'up-flow-iframe.common.ui.commerce-api-error-flag.show-flag.error',
        messageType: 'transactional'
    });
    return null;
};

});
parcelRegister("58Vhi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f916e4fd0a7e538$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6f916e4fd0a7e538$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.title",
        "defaultMessage": "We can't upgrade your plan right now"
    },
    description: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.description",
        "defaultMessage": "Try again, or if this keeps happening try contacting support"
    }
});

});



parcelRegister("eVWQM", function(module, exports) {

$parcel$export(module.exports, "ChunkLoadErrorFlag", () => $a39f6b875be38cdc$export$7a9d9407b3a5f50e);

var $bILK0 = parcelRequire("bILK0");

var $hrodw = parcelRequire("hrodw");

var $7Jk3f = parcelRequire("7Jk3f");

var $04e9P = parcelRequire("04e9P");
const $a39f6b875be38cdc$export$7a9d9407b3a5f50e = ({ error: error })=>{
    const flagKey = (0, $hrodw.toFlagId)('chunk-load-error');
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    if ((0, $7Jk3f.isLoaderError)(error)) showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $04e9P.default).title,
        description: (0, $04e9P.default).description,
        isAutoDismiss: true,
        messageId: 'up-flow-iframe.ui.chunk-load-error-flag.show-flag.error',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $04e9P.default).refreshPageButton,
                onClick: ()=>{
                    dismissFlag(flagKey);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location.reload();
                }
            }
        ]
    });
    return null;
};

});
parcelRegister("04e9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $98f992ee7dbad804$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $98f992ee7dbad804$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "up-flow-iframe.chunk-load-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "up-flow-iframe.chunk-load-error-flag.description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshPageButton: {
        "id": "up-flow-iframe.chunk-load-error-flag.refresh-page-button",
        "defaultMessage": "Refresh page"
    }
});

});


parcelRegister("61XLP", function(module, exports) {

let $46413335a287be79$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $46413335a287be79$var$load("7mIf9"),
    $46413335a287be79$var$load("jXweD"),
    $46413335a287be79$var$load("76n7a"),
    $46413335a287be79$var$load("l253H"),
    $46413335a287be79$var$load("kVX56"),
    $46413335a287be79$var$load("5qUb7")
]).then(()=>parcelRequire('cZe96'));

});




//# sourceMappingURL=async-upflow-iframe-entrypoint.cf793f16.js.map
